import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { shopBreadcrumbs } from '../Breadcrumbs/constants';
import { getShop } from './queries';
import css from './Shop.module.scss';
import Breadcrumbs from '../Breadcrumbs';
import Phone from '../icons/Phone';
import EmailSMSSignUp from '../EmailSMSSignUp';
import Email from '../icons/Email';
import { Category } from '../../apps/pages/help-center/Category';
import { Button } from '@outdoor-voices/ui';
import ImageCarousel from '../ImageCarousel';
import LinkBlocks from '../LinkBlocks';
import Pin from '../icons/Pin';
import PinOutline from './PinOutline';
import ShopMap from './ShopMap';
import UpcomingEvent from './UpcomingEvent';
import validEmail from '../../utils/strings/validEmail';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ContactLink = function ContactLink(_ref) {
  var ariaLabel = _ref.ariaLabel,
      icon = _ref.icon,
      text = _ref.text,
      type = _ref.type,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("li", {
    className: css.contactLinkWrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.iconWrapper,
      children: /*#__PURE__*/_jsx("div", {
        className: cc([css.icon, css[type]]),
        children: icon
      })
    }), /*#__PURE__*/_jsx("a", {
      "aria-label": ariaLabel,
      className: css.link,
      href: url,
      children: text
    })]
  });
};

ContactLink.propTypes = {
  ariaLabel: PropTypes.string,
  icon: PropTypes.shape().isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

var Hiring = function Hiring() {
  return /*#__PURE__*/_jsxs("div", {
    className: css.hiring,
    children: [/*#__PURE__*/_jsx("h3", {
      className: css.hiringTitle,
      children: "Join Team OV"
    }), /*#__PURE__*/_jsx("p", {
      className: css.hiringCopy,
      children: "We\u2019re always on the lookout for Recreationalists to join our roster. Wanna team up?"
    }), /*#__PURE__*/_jsx("a", {
      "aria-label": 'Click to view our job listings',
      className: cc([css.url, css.hiringUrl]),
      href: 'https://www.outdoorvoices.com/pages/careers',
      children: "Check out our open positions"
    })]
  });
};

var FAQs = function FAQs(_ref2) {
  var articles = _ref2.articles;
  var selectedFAQIDs = ['635305004896d3fd81aef9a8', '633353cfb0864dea16815b67', '63bdda9ffd3f0ff160cd68fa', '63334ba19e66fa3e3d3c8004'];
  var selectedFAQs = articles.filter(function (article) {
    return selectedFAQIDs.includes(article.id);
  });
  return /*#__PURE__*/_jsxs("section", {
    className: cc([css.section, css.faqs]),
    children: [/*#__PURE__*/_jsx("h4", {
      className: cc([css.title, css.center]),
      children: "Retail FAQs"
    }), /*#__PURE__*/_jsx("div", {
      className: css.faqsWrapper,
      children: /*#__PURE__*/_jsx(Category, {
        articles: selectedFAQs
      })
    }), /*#__PURE__*/_jsx(Button, {
      big: true,
      className: css.button,
      href: "/pages/help-center-retail",
      children: "View All FAQs"
    })]
  });
};

FAQs.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

var Form = function Form(_ref3) {
  var accentColor = _ref3.accentColor,
      backgroundColor = _ref3.backgroundColor,
      city = _ref3.city,
      signupFormId = _ref3.signupFormId;

  /* eslint-disable max-len */
  var blurb = "Sign up to be the first to know when OV ".concat(city, " opens and get invited to exclusive in-market events.");
  var disclaimer = "By submitting your phone number, you agree to receive recurring automated marketing text messages. Consent is not a condition of purchase. Reply HELP for help and STOP to cancel. Message frequency varies by account. Message and data rates may apply. See <a href=\"/privacy-policy\" style=\"color: ".concat(accentColor, "\">Privacy Policy</a> and <a href=\"https://assets.conciergeteam.co/clients/outdoorvoices/sms_terms.html\" style=\"color: ").concat(accentColor, "\">SMS Terms</a>");
  var successMessage = 'Game on. Look out for an email or text message from us soon.';
  var emailProps = {
    klaviyoListId: signupFormId,
    klaviyoListSource: "".concat(city, " Shop Email Sign Up"),
    successMessage: successMessage
  };
  return /*#__PURE__*/_jsxs("div", {
    className: css.signupFormWrapper,
    style: {
      color: "".concat(accentColor),
      backgroundColor: "".concat(backgroundColor)
    },
    children: [/*#__PURE__*/_jsx("h3", {
      className: css.blurb,
      children: blurb
    }), /*#__PURE__*/_jsx(EmailSMSSignUp, _objectSpread({}, emailProps)), /*#__PURE__*/_jsx("p", {
      className: css.disclaimer,
      dangerouslySetInnerHTML: {
        __html: disclaimer
      }
    })]
  });
};

Form.propTypes = {
  accentColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  city: PropTypes.string.isRequired,
  signupFormId: PropTypes.string.isRequired
};

var Shop = function Shop(_ref4) {
  var shop = _ref4.shop,
      shopsFAQArticles = _ref4.shopsFAQArticles,
      shopPageArticles = _ref4.shopPageArticles;
  var accentColor = shop.accentColor,
      backgroundColor = shop.backgroundColor,
      city = shop.city,
      comingSoon = shop.comingSoon,
      description = shop.description,
      email = shop.email,
      eventsMarketSlug = shop.eventsMarketSlug,
      hours = shop.hours,
      shopImages = shop.images,
      lat = shop.lat,
      lng = shop.lng,
      phoneNumber = shop.phoneNumber,
      signupFormId = shop.signupFormId,
      state = shop.state,
      streetAddress = shop.streetAddress,
      subtitle = shop.subtitle,
      tagline = shop.tagline,
      title = shop.title,
      zipCode = shop.zipCode;
  var hasMap = lat !== null && lng !== null;
  var images = shopImages.edges.map(function (item) {
    return item.node;
  });
  var hasImages = images.length !== 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Breadcrumbs, {
      breadcrumbsList: shopBreadcrumbs,
      pageTitle: title
    }), /*#__PURE__*/_jsxs("section", {
      className: cc([css.section, css.details]),
      children: [/*#__PURE__*/_jsxs("div", {
        className: css.info,
        children: [/*#__PURE__*/_jsxs("header", {
          className: css.header,
          children: [/*#__PURE__*/_jsxs("div", {
            className: css.titleWrapper,
            children: [/*#__PURE__*/_jsx(Pin, {
              color: backgroundColor
            }), /*#__PURE__*/_jsx("h1", {
              className: css.title,
              children: title
            })]
          }), /*#__PURE__*/_jsx("h2", {
            className: css.subtitle,
            children: subtitle
          })]
        }), /*#__PURE__*/_jsxs("ul", {
          className: css.contactLinks,
          children: [!comingSoon && /*#__PURE__*/_jsx(ContactLink, {
            ariaLabel: "Call the ".concat(title, " shop at ").concat(phoneNumber),
            icon: /*#__PURE__*/_jsx(Phone, {}),
            text: phoneNumber,
            type: 'phone',
            url: "tel:".concat(phoneNumber)
          }, "Contact Via Phone"), validEmail(email) && /*#__PURE__*/_jsx(ContactLink, {
            ariaLabel: "Send an email to the ".concat(title, " shop at ").concat(email),
            icon: /*#__PURE__*/_jsx(Email, {}),
            text: email,
            type: 'email',
            url: "mailto:".concat(email)
          }, "Contact Via Email"), /*#__PURE__*/_jsx(ContactLink, {
            ariaLabel: "Get Google Maps directions to the ".concat(title, " shop at ").concat(streetAddress),
            icon: /*#__PURE__*/_jsx(PinOutline, {}),
            text: streetAddress,
            type: 'contactPin',
            url: "https://maps.google.com/?q=Outdoor Voices,".concat(streetAddress, " ").concat(city, ", ").concat(state, " ").concat(zipCode)
          }, "Get Directions")]
        }), /*#__PURE__*/_jsxs("div", {
          className: cc([css.hours]),
          children: [/*#__PURE__*/_jsx("h3", {
            className: cc([css.title, css.small]),
            children: "Hours"
          }), hours.edges.map(function (_ref5) {
            var _ref5$node = _ref5.node,
                id = _ref5$node.id,
                label = _ref5$node.label,
                times = _ref5$node.times;
            return /*#__PURE__*/_jsxs("div", {
              className: css.hour,
              children: [/*#__PURE__*/_jsx("span", {
                children: label
              }), times && /*#__PURE__*/_jsx("span", {
                children: times
              })]
            }, id);
          })]
        }), !comingSoon && /*#__PURE__*/_jsx(UpcomingEvent, {
          eventsMarketSlug: eventsMarketSlug
        }), comingSoon && /*#__PURE__*/_jsx(Hiring, {})]
      }), hasMap && /*#__PURE__*/_jsx(ShopMap, {
        lat: lat,
        lng: lng
      })]
    }), /*#__PURE__*/_jsxs("section", {
      className: cc([css.section, css.about]),
      children: [/*#__PURE__*/_jsx("h4", {
        className: css.tagline,
        children: tagline
      }), description && /*#__PURE__*/_jsx("p", {
        className: css.description,
        children: description
      })]
    }), comingSoon && /*#__PURE__*/_jsx("section", {
      className: cc([css.section, css.comingSoonForm]),
      children: /*#__PURE__*/_jsx(Form, {
        accentColor: accentColor,
        backgroundColor: backgroundColor,
        city: city,
        signupFormId: signupFormId
      })
    }), !comingSoon && /*#__PURE__*/_jsxs(_Fragment, {
      children: [hasImages && /*#__PURE__*/_jsx("section", {
        className: css.imageCarousel,
        children: /*#__PURE__*/_jsx(ImageCarousel, {
          items: images,
          name: "".concat(city, " shop page"),
          removeOuterMargins: true
        })
      }), /*#__PURE__*/_jsx(FAQs, {
        articles: shopsFAQArticles
      })]
    }), /*#__PURE__*/_jsx("section", {
      className: cc([css.section, css.linkBlocksWrapper]),
      children: /*#__PURE__*/_jsx(LinkBlocks, {
        center: true,
        items: shopPageArticles
      })
    })]
  });
};

Shop.propTypes = {
  shop: PropTypes.shape().isRequired,
  shopsFAQArticles: PropTypes.arrayOf(PropTypes.shape()),
  shopPageArticles: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

var ShopLoader = function ShopLoader(_ref6) {
  var loadingHTML = _ref6.loadingHTML,
      shopifyId = _ref6.shopifyId;
  var retailCategoryID = '6169ae3bcf9e8d0014040a11';

  var _useQuery = useQuery({
    query: getShop,
    variables: {
      categoryId: retailCategoryID,
      shopifyId: shopifyId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      fetching = _useQuery2$.fetching,
      data = _useQuery2$.data,
      error = _useQuery2$.error;

  if (fetching) {
    return /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: loadingHTML
      }
    });
  }

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsxs("div", {
      className: css.errorRoot,
      "data-testid": "error",
      children: [/*#__PURE__*/_jsx("h2", {
        children: "Oops... something went wrong."
      }), /*#__PURE__*/_jsx("p", {
        className: css.details,
        children: error.message
      })]
    });
  }

  var shopsFAQArticles = data.faqsCategory.articles,
      shop = data.shop,
      shopPageArticles = data.shopPageArticles;
  return /*#__PURE__*/_jsx(Shop, {
    shop: shop,
    shopsFAQArticles: shopsFAQArticles,
    shopPageArticles: shopPageArticles
  });
};

ShopLoader.propTypes = {
  loadingHTML: PropTypes.string,
  shopifyId: PropTypes.string.isRequired
};
export default ShopLoader;